module.exports = "/images/logo-white-beta.svg?efac3a2982602bcbf7ccd66ff5c22908";